import type {Notification} from './notifications.types'

const default_seed: Notification[] = [
	{
		id: 'n1',
		title: 'Willkommen',
		body: 'Dein Konto ist eingerichtet.',
		timestamp: '2026-05-12T08:00:00Z',
		read: false
	},
	{
		id: 'n2',
		title: 'Neues Match',
		body: 'Ein neuer Standort passt zu Deinem Profil.',
		timestamp: '2026-05-11T17:30:00Z',
		read: false
	},
	{
		id: 'n3',
		title: 'Projektaktualisierung',
		body: 'Der Status von Projekt FAK-1312 hat sich geändert.',
		timestamp: '2026-05-10T12:15:00Z',
		read: false
	},
	{
		id: 'n4',
		title: 'Erinnerung',
		body: 'Das Angebot läuft in 2 Tagen ab.',
		timestamp: '2026-05-08T09:00:00Z',
		read: true
	}
]

export class NotificationsFeed {
	items = $state<Notification[]>([])

	constructor(seed?: Notification[]) {
		this.items = seed ?? default_seed.map((n) => ({ ...n }))
	}

	get hasUnread() {
		return this.items.some((n) => !n.read)
	}

	markRead(id: string) {
		const n = this.items.find((x) => x.id === id)
		if (n) n.read = true
	}
}

export const notificationsFeed = new NotificationsFeed()
